<template>
  <div class="hl-loading-item">
    <div class="hl-item-title">
      <span class="text-primary">{{ data.title }}</span>
      <button class="hl-close-btn" @click="removeLoadingItem(data.id)" v-if="data.succeedItems === data.totalItems">
        <icon icon="times" />
      </button>
    </div>
    <div class="hl-progress-container">
      <div class="hl-progress-percentage" :class="{ 'hl-green': data.progress === 100 }">{{ data.progress === 100 ? $t('hard-loading.success-msg') : `${data.progress}%` }}</div>
      <div class="hl-progress-bar">
        <div class="hl-progress-fill" :class="{ 'hl-progress-fill-success': data.progress === 100 }" :style="{ width: `${data.progress}%` }"></div>
      </div>
      <div class="hl-progress-percentage">{{ data.totalItems }} / <span class="hl-green">{{ data.succeedItems }}</span></div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import { HardLoadingItem } from './hard-loading'
  import { removeLoadingItem } from '@/plugins/hard-loading'

  export default defineComponent({
    name: 'HardLoadingItem',
    props: {
      data: { type: Object as PropType<HardLoadingItem>, required: true }
    },
    methods: {
      removeLoadingItem
    }
  })
</script>